import { post } from "@/services/http/platformServer";

export enum GiftItemPushType {
    /** 跟随其他商品一起提交 */
    PUSH_WITH_OTHER_ORDER = "PUSH_WITH_OTHER_ORDER",
}

export interface PushOrderToSupplierSetting {
    retailerShopId: number;
    needOrderAmount: boolean;
    needProductPrice: boolean;
    dateCreated: string;
    lastUpdated: string;
    giftItemPushType?: GiftItemPushType;
}

/**
 * 获取分销自动推单设置
 */
export function getPushOrderToSupplierSetting(shopId: number) {
    return post<PushOrderToSupplierSetting>(shopId, "/push_order_to_supplier_setting/get", {
        shopId,
    });
}

interface SaveParams extends Omit<PushOrderToSupplierSetting, "lastUpdated" | "dateCreated"> {
    pushGiftItemWithOtherOrder: boolean;
}

export function savePushOrderToSupplierSetting(params: SaveParams): Promise<PushOrderToSupplierSetting> {
    return post(params.retailerShopId, "/push_order_to_supplier_setting/save", params);
}
